import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { Injectable } from '@angular/core';
import { EncodingService } from './encoding.service';
import { environment } from '../../environments/environment';
@Injectable({
  providedIn: 'root'
})
export class OptionsService {
  //baseURL = 'http://localhost:3000';
  baseURL = environment.backend_base_url;

  allOptionsCache: any = null;

  constructor(
    public _http: HttpClient
  ) { }  

  getOptionById(id: string) {
    
    const url = `${this.baseURL}/api/options/${id}`;
    return this._http.get<any>(url).pipe(
      map(response => {
        console.log("Get Option By ID response:", response);
        return response;
      })
    );
  }

  getAllOptions() {
    if (this.allOptionsCache) {
      // Return cached data as an observable
      return new Observable(observer => {
        observer.next(this.allOptionsCache);
        observer.complete();
      });
    }
    const url = `${this.baseURL}/api/options/all`;
    return this._http.get<any>(url).pipe(
      map(response => {
        console.log("Get All Options response:", response);
        response.sort((a: any, b: any) => a.name.localeCompare(b.name));
        this.allOptionsCache = response; // Cache the response
        return response;
      })
    );
  }

  /**
   * Update an options value field using the id
   * @param id id value for the option to update
   * @param data data for the value field to update
   * @returns 
   */
  updateOption(id: string, data: any) {
    const url = `${this.baseURL}/api/options/edit/${id}`;
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this._http.post<any>(url, data, { headers }).pipe(
      map(response => {
        console.log("Edit Option response:", response);
        // Clear cache to force refresh
        this.allOptionsCache = null;
        return response.rows[0];
      })
    );
  }
}
